import { default as LoginPageGeneric } from 'components/login/LoginPage'
import React from 'react'

const LoginPage = (props) => {
    const redirectFunc = (user) => {
        if (user) {
            return '/service/requests'
        }
    }

    return <LoginPageGeneric {...props} defaultRedirect={redirectFunc} />
}

export default LoginPage
